function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import color from 'color';
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    base: _defineProperty({
      backgroundColor: colors.monotone1,
      borderRadius: 0,
      border: '1px solid transparent',
      color: colors.white,
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: 1.3,
      width: '100%',
      maxWidth: '320px',
      outline: 'none',
      padding: '12px 16px 9px',
      textAlign: 'center',
      textDecoration: 'none',
      textTransform: 'uppercase',
      transition: 'background-color .2s ease-in-out, color .2s ease-in-out, border-color .2s ease-in-out',
      verticalAlign: 'top',
      position: 'relative',
      WebkitAppearance: 'none',
      '& svg': {
        transition: 'fill .2s ease-in-out'
      }
    }, mediaQueries.breakpointSmall, {
      display: 'block',
      maxWidth: '100%',
      minWidth: 'auto'
    }),
    kindPrimary: {
      backgroundColor: colors.primary,
      '&:hover': {
        backgroundColor: colors.primaryDarker
      },
      '&:focus': {
        boxShadow: "0 0 4px 2px ".concat(colors.blue)
      },
      '&:active': {
        backgroundColor: color(colors.primaryDarker).darken(0.2).hex(),
        color: '#BAE053'
      },
      '& svg': {
        fill: colors.white
      }
    },
    kindSecondary: {
      backgroundColor: colors.gray,
      '&:hover': {
        backgroundColor: colors.grayDark
      },
      '& svg': {
        fill: colors.white
      }
    },
    kindSimple: {
      color: colors.secondary,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: "1px solid ".concat(colors.secondary),
      '&:hover': {
        backgroundColor: colors.secondary,
        color: colors.white,
        '& svg': {
          fill: colors.white
        }
      },
      '&:focus': {
        boxShadow: "0 0 4px 2px ".concat(colors.primary)
      },
      '&:active': {
        backgroundColor: color(colors.secondaryDarker).darken(0.2).hex(),
        color: '#2DB874'
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        border: "1px solid ".concat(colors.grayBlue),
        color: colors.grayBlue,
        boxShadow: 'none',
        '& svg': {
          fill: colors.grayBlue
        }
      },
      '& svg': {
        fill: colors.secondary
      }
    },
    kindDark: {
      backgroundColor: colors.secondary,
      '&:hover': {
        backgroundColor: colors.secondaryDarker
      },
      '&:focus': {
        boxShadow: "0 0 4px 2px ".concat(colors.primary)
      },
      '&:active': {
        backgroundColor: color(colors.secondaryDarker).darken(0.2).hex(),
        color: '#2DB874'
      },
      '& svg': {
        fill: colors.white
      }
    },
    kindWhite: {
      backgroundColor: colors.white,
      color: colors.secondary,
      boxShadow: 'none',
      border: "1px solid ".concat(colors.secondary),
      '&:hover': {
        backgroundColor: colors.secondaryDarker,
        color: colors.white,
        '& svg': {
          fill: colors.white
        }
      },
      '&:focus': {
        boxShadow: "0 0 4px 2px ".concat(colors.primary)
      },
      '&:active': {
        backgroundColor: color(colors.secondaryDarker).darken(0.2).hex(),
        color: '#2DB874'
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        border: "1px solid ".concat(colors.grayBlue),
        color: colors.grayBlue,
        boxShadow: 'none',
        '& svg': {
          fill: colors.grayBlue
        }
      },
      '& svg': {
        fill: colors.secondary
      }
    },
    fullWidth: {
      maxWidth: '100%'
    },
    disabled: {
      cursor: 'default',
      pointerEvents: 'none',
      userSelect: 'none',
      color: colors.white,
      backgroundColor: colors.whiteDark
    },
    loading: {
      // Styles for loader
      '& span > div': {
        position: 'absolute',
        left: '12px',
        top: '50%',
        transform: 'translateY(-50%)'
      }
    },
    sizeSmall: _defineProperty({
      fontSize: '14px',
      padding: '0px 10px'
    }, mediaQueries.breakpointLarge, {
      minWidth: 0,
      width: 'auto'
    }),
    sizeLarge: {
      padding: '25px 30px',
      fontSize: '18px'
    },
    externalIcon: {
      position: 'absolute',
      top: '4px',
      right: '4px',
      width: '10px',
      height: '10px',
      fill: colors.white
    },
    icon: {
      width: '15px',
      height: '15px',
      marginRight: '12px'
    }
  };
});